module.exports = __webpack_public_path__ + "static/media/Imageblue.4e077f67.svg";